module.exports = __webpack_public_path__ + "img/thumbnail-banner-calyrafit.04de8016.webp";